import { useEffect, useState } from 'react';
import { _FixedAssetItem } from '../../../../../../core/services/dataBean/EntityCatalogVdos';
import useDataBean from '../../../../../../core/services/dataBean/useDataBean';
import { _single } from '../../../../../../core/services/dataBean/EntityCatalog';
import { Modal } from '../../../../../theme/Component/Modal';
import { BasicTable } from '../../../../../theme/Component/BasicTable';
import usePaginator from '../../../../../theme/Component/usePaginator';
import { BasicButton } from '../../../../../theme/Component/BasicButton';
import { SelectFixedAsset } from './FixedAsset/SelectFixedAsset';
import { toast } from 'react-toastify';
import { PrintJson } from '../../../../../theme/Component/PrintJson';

interface Props {
    label?: string;
    onChange?: any;
    StateActive?: any;
}

export const RemoteFixedAssetItem = ({ label, onChange, StateActive }: Props) => {

    const { lista, setLista, bean, setBean, instance } = useDataBean(_FixedAssetItem);
    const [response, setResponse] = useState<any>({});
    const paginador = usePaginator();

    const [modal, setModal] = useState<any>({ name: 'Buscar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });

    const getLista = () => {
        instance.getFixedAssetItemsForEditor(response.Regex, response.IDFixedAsset, StateActive ?? []).then(
            (resp) => {
                setLista(resp)
                setModal({ ...modal, "view": true })
            }
        ).catch(
            err => {
                console.log(err)
            }
        );
    }

    useEffect(() => {
        if (modal.view) {
            setResponse({});
            setLista([]);
        }
    }, [modal.view])

    const head = [
        { title: 'ID', property: 'IDItem', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Fecha Evento', property: 'InitDate', visible: true },
        { title: 'Placa', property: 'TicketCode', visible: true },
        { title: 'Disponibilidad', property: 'StateName', visible: true },
        { title: 'Cantidad', property: 'Quantity', visible: true },
        { title: 'Responsable', property: 'ResponsibleName', visible: true },
        { title: 'Línea/Grupo de Activos', property: 'FixedAssetLineName', visible: true },
        { title: 'Ubicación', property: 'StoreName', visible: true },
        { title: 'Estado del Bien', property: 'FixedAssetStateName', visible: true },
        { title: 'Serial', property: 'SerialNumber', visible: true },
        { title: 'Cuenta Contable', property: 'AccountantIDName', visible: true },
        { title: 'Tipo Documento', property: 'Mnemonic', visible: true },
        { title: 'Numero Documento', property: 'Consecutive', visible: true },
        { title: 'Controlado', property: 'Checked', visible: true },
        { title: 'Cuentas de Orden', property: 'OrderAccountant', visible: true },
        { title: 'Causa de la Baja', property: 'ItemDownCauseName', visible: true },
        { title: 'Tiempo Depreciación', property: 'DepreciationTime', visible: true },
        { title: 'Tiempo Depreciación Fiscal', property: 'FiscalDepreciationTime', visible: true },
        { title: 'Adición NIIF', property: 'NiifAdditionValue', visible: true },
        { title: 'Adición Fiscal', property: 'FiscalAdditionValue', visible: true },
        { title: 'Dependencia', property: 'IDLnFunctionalID', visible: true },
        { title: 'Centro de Costo', property: 'CostingCenterCode', visible: true },
        { title: 'Unidad de Negocio', property: 'IDBusinessCore', visible: true },
        { title: 'Reconocimiento NIIF Inicial', property: 'NiifInitialValue', visible: true },
        { title: 'Valor Residual', property: 'ResidualValue', visible: true },
        { title: 'Usar Cuenta Servicio en Ops NIIF', property: 'UseBrandIDForAllOps', visible: true },
        { title: 'No depreciar ni amortizar', property: 'NotDepreciateOrAmortize', visible: true },
        { title: 'Observaciones', property: 'Observations', visible: true },
    ]

    const selectItem = () => {
        if (bean.IDItem) {
            setModal({ ...modal, "view": false });
            onChange?.(bean);
        } else {
            toast.error("Item no valido")
        }
    };

    const hasValidFilter = () => {
        return Object.values(response).some(value =>
            value !== undefined &&
            value !== null &&
            !(typeof value === 'string' && value.trim() === '')
        );
    };

    useEffect(() => {
        if (hasValidFilter()) {
            getLista();
        }
    }, [paginador.page]);

    useEffect(() => {
        if (response.IDFixedAsset) {
            getLista();
        }
    }, [response.IDFixedAsset])

    return (
        <>
            <label>{label ? label : 'Item/Placas de Activos Fijos'}</label>
            <input
                type="text"
                className="form-control"
                aria-label="Recipient's username"
                aria-describedby="button-addon2"
                placeholder="Buscar..."
                value={bean.IDStore ? `${bean.IDStore} - ${bean.Name}` : ""}
                onClick={() => { setModal({ ...modal, "view": true }) }}
            />

            <Modal modal={modal} updateModal={setModal} eventModal={() => { selectItem() }} onSubmitLabel='Seleccionar'>
                <div className="row">
                    <div className="col-md-6">
                        <label>Búsqueda Placa</label>
                        <input type="Number" className='form-control' onBlur={(() => {
                            if (response.Regex) {
                                getLista()
                            }
                        })} value={response.Regex} onChange={(e) => {
                            const rawValue = e.target.value;
                            const value = rawValue === "" ? null : Number(rawValue);
                            setResponse({ ...response, "Regex": value })
                        }} />
                    </div>
                    <div className="col-md-6">
                        <SelectFixedAsset idSelector={response.IDFixedAsset} onChange={(e) => { setResponse({ ...response, "IDFixedAsset": e }) }} />
                    </div>
                </div>
                <BasicTable
                    body={lista}
                    head={head}
                    rowSet={setBean}
                    records={paginador}
                />
            </Modal>
        </>
    );
}
